// "$7.00", "-$87.23": dollar amounts for the Orders cells (CAD, as the
// shipment and fulfilment costs are). The sign goes before the $.
export const formatMoney = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "-";
  return `${amount < 0 ? "-" : ""}$${Math.abs(amount).toFixed(2)}`;
};
